import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserEdit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.522 19.806-.751.126a.84.84 0 0 1-.974-.919l.083-.775c.04-.373.197-.724.448-1.006l2.954-3.253a1.03 1.03 0 0 1 1.456-.056l.69.639a1.03 1.03 0 0 1 .056 1.455l-2.919 3.214c-.272.305-.64.508-1.043.575M14.491 7.996a3.996 3.996 0 1 1-7.991 0 3.996 3.996 0 0 1 7.991 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.496 14.875c-3.376 0-6.255.51-6.255 2.553s2.863 2.571 6.255 2.571"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserEdit);
export default ForwardRef;
